import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const useIdleTimer = (timeout = 120000) => {
  const [isIdle, setIsIdle] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    let timeoutId;

    const resetTimeout = () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      timeoutId = setTimeout(() => {
        setIsIdle(true);
      }, timeout); // 1 minute of inactivity
    };

    const handleActivity = () => {
      setIsIdle(false);
      resetTimeout(); // Reset the timer on any activity
    };

    // Event listeners for user activity
    window.addEventListener('mousemove', handleActivity);
    window.addEventListener('keydown', handleActivity);
    window.addEventListener('click', handleActivity);

    resetTimeout(); // Start the timer initially

    return () => {
      clearTimeout(timeoutId); // Cleanup the timeout
      window.removeEventListener('mousemove', handleActivity);
      window.removeEventListener('keydown', handleActivity);
      window.removeEventListener('click', handleActivity);
    };
  }, [timeout]);

  useEffect(() => {
    if (isIdle) {
      // When the user is idle for 1 minute
      localStorage.clear(); // Clear local storage
      navigate('/'); // Redirect to login page
    }
  }, [isIdle, navigate]);
};

export default useIdleTimer;
